import React from 'react';
import Link from '../Link/Link';

const FeaturedEvent = ({ event }) => {
  if (!event) return null;

  const { title, date, image, url } = event;

  return (
    <Link fullUrl={url} className="featured-card-link">
      <div className="featured-card featured-card--event">
        <div className="featured-card__image-container">
          {image ? (
            <img src={image} alt={title} />
          ) : (
             <div className="featured-card__no-image-placeholder"></div>
          )}
        </div>
        <h3 className="featured-card__title">{title}</h3>
        {date && <p className="featured-card__detail">{date}</p>}
      </div>
    </Link>
  );
};

export default FeaturedEvent;
